import styled from "styled-components";

import { lighten, rgba } from "polished";
import { Box } from "../ppui";
import { Flex } from "../ppui/layout";
import { theme } from "../theme";

// Common component mixins
const cardStyles = {
  borderRadius: theme.radius.xl,
  backgroundColor: theme.colors.light.light,
  boxShadow: theme.shadow.md,
  padding: theme.space[5],
};
export const ContentLayout = styled("section")(() => ({
  position: "relative",
  height: "100%",
  width: "100%",
  padding: "1.25rem",
}));

export const ContentHeading = styled(Flex)(() => ({
  paddingBlockEnd: "1.25rem",
  alignItems: "center",
  justifyContent: "space-between",
}));
export const ContentBody = styled(Box)(({ Padding }) => ({
  backgroundColor: theme.colors.light.light,
  borderRadius: theme.radius.card,
  padding: Padding && "1.25rem",
  "& + &": { marginBlockStart: "2.5rem" },
}));
export const ContentWrapper = styled(ContentBody)(() => ({ display: "flex" }));
export const ContentTable = styled(ContentBody)(() => ({
  display: "flex",
  flex:1,
  flexDirection: "column",
}));
export const ContentMenu = styled(Box)(() => ({
  padding: "1.25rem",
  width: "30%",
  maxWidth: "20rem",
  borderInlineEnd: `${theme.colors.default.main} solid 0.0625rem`,
}));
export const ContentMenuSticky = styled(Box)(() => ({
  position:'sticky',
  top:'17.5rem'
}));
export const ContentForm = styled(Box)(() => ({
  padding: "1.25rem",
  width: "70%",
  flexGrow: 1,
  flexBasis: 0,
}));

export const EmployeeWrapper = styled(Box)(() => ({
  position: "sticky",
  top: "4.375rem",
  left: "0",
  zIndex: "10",
  backgroundColor: theme.colors.background.main,
  paddingBlock:"1.25rem",
  marginBlockStart:"-1.25rem",
}));
export const EmployeeHeader = styled(ContentBody)(() => ({
  maxHeight: "13.75rem",
  backgroundColor: theme.colors.primary.light,
  overflow:"hidden",
  display:'flex',
  alignItems:'center',
  gap:"7.5rem",
  position:"relative",
  padding:"0.9375rem 1.25rem" ,
}));

export const EmployeeName = styled(Box)(() => ({
  position:"relative",
  flex:1
}));



export const PhotoView = styled(Flex)(() => ({
  alignItems: "center",
  justifyContent: "center",
  width: "7.5rem",
  height: "7.5rem",
  border: `solid 0.25rem ${theme.colors.light.light}`,
  backgroundColor: theme.colors.primary.light,
  borderRadius: "50%",
  position: "relative",
  boxShadow: `0.25rem 0.25rem 0.625rem ${rgba(theme.colors.dark.dark, 0.1)} `,
  color:theme.colors.background.main,
  fontSize:"2.5rem",
  fontWeight:700,
  textShadow: `0.125rem 0.125rem 0.125rem ${rgba(theme.colors.dark.dark, 1)} `, 
  // "&:before":{
  //   content:`""`,
  //   position:"absolute",
  //   width: "100%",
  //   height: "100%",
  //   backgroundColor: theme.colors.primary.main,
  //   borderRadius: "50%",
  // },
  "& svg": {
    width: "2.5rem",
    height: "2.5rem",
  },
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%",
  },
}));
export const PhotoUpload = styled(Flex)(() => ({
  alignItems: "center",
  justifyContent: "center",
  width: "7.5rem",
  height: "7.5rem",
  border: `solid 0.5rem ${theme.colors.light.main}`,
  backgroundColor: theme.colors.default.main,
  borderRadius: "50%",
  position: "relative",
  "& svg": {
    width: "2.5rem",
    height: "2.5rem",
  },
  "& input": {
    width: "100%",
    height: "100%",
    position: "absolute",
    left: 0,
    top: 0,
    opacity: 0,
    borderRadius: "50%",
  },
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%",
  },
}));
export const PhotoIcon = styled(Flex)(() => ({
  alignItems: "center",
  justifyContent: "center",
  width: "2.5rem",
  height: "2.5rem",
  border: `solid 0.25rem ${theme.colors.light.main}`,
  backgroundColor: theme.colors.default.main,
  borderRadius: "50%",
  overflow: "hidden",
  position: "absolute",
  right: "-0.5rem",
  bottom: "-0.5rem",
}));

export const AllowanceBox = styled(Flex)((props) => {
  const { bgColor } = props;
  return {
  backgroundColor: bgColor || lighten(0.35, theme.colors.secondary.main),
  padding: "0.625rem 0.75rem",
  fontFamily: theme.typography.fontFamily,
  borderRadius: theme.radius.list,
  alignItems: "center",
  "&>div": { alignItems: "center" },
  "& .label": { fontSize: "0.75rem", marginBlockEnd: "0.125rem" },
  "& .value": { fontSize: "0.875rem", fontWeight: 500,},
  }

});

export const Epffileicon = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  marginLeft: "0.625rem",
  width: "1.25rem",
}));

// Slabe-table
export const CustomTable = styled("table")(() => ({
  width: "100%",
  border: `solid 0.0625rem ${theme.colors.light.dark}`,
  borderCollapse: "collapse",
}));
export const CustomTableHeader = styled("thead")(() => ({
  border: `solid 0.0625rem ${theme.colors.light.dark}`,
}));
export const CustomTableBody = styled("tbody")(() => ({}));
export const CustomTableFooter = styled("thead")(() => ({
  border: `solid 0.0625rem ${theme.colors.light.dark}`,
  backgroundColor: lighten(0.1, theme.colors.light.dark),
}));
export const Tr = styled("tr")(() => ({}));
export const Th = styled("th")(({ align }) => ({
  borderRight: `solid 0.0625rem ${theme.colors.light.dark}`,
  padding: "0.625rem",
  "& > p": { textAlign: align || "left" },
}));
export const Td = styled("td")(({ align }) => ({
  borderRight: `solid 0.0625rem ${theme.colors.light.dark}`,
  padding: "0.625rem",
  "& > p": { textAlign: align || "left" },
}));

// Labour-Welfare-Table
export const LabourWelfareTable = styled("table")(() => ({
  width: "100%",
  borderCollapse: "collapse",
  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
}));
export const LabourWelfareHeader = styled("thead")(() => ({}));
export const LabourWelfareTr = styled("tr")(() => ({}));
export const LabourWelfareTh = styled("th")(() => ({
  padding: "0.625rem",
}));
export const LabourWelfareBody = styled("tbody")(() => ({}));
export const LabourWelfareTd = styled("td")(() => ({
  padding: "0.625rem",
}));

// Oraganisation-employee-details


export const OrganizationEmDetails = styled(Box)(({Gap}) => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  width: "100%",
  gap: `${theme.space[6]}`,
  flexDirection: "row",
  justifyContent: Gap && "stretch",
}));
export const OrganizationBx = styled(Flex)(({autoWidth}) => ({
  // width: ` calc((100% -  ${theme.space[12]} ) / 3 )`,
  minWidth: "16.25rem",
  maxWidth: autoWidth ? "auto":"16.25rem",
  gap: theme.space[3],
  alignItems: "start",
}));
export const ListingBx = styled(Box)(() => ({
  width: "calc((100% / 3) - 0.625rem)",
}));

export const OrganizationWrapper = styled(Box)(() => ({
  position: "sticky",
  top: "4.375rem",
  left: "0",
  zIndex: "10",
  backgroundColor: theme.colors.background.main,
  paddingBlock:"1.25rem",
  marginBlockStart:"-1.25rem",
}));
export const OrganizationHeader = styled(ContentBody)(() => ({
  height: "9.375rem",
  backgroundColor: theme.colors.primary.light,
  overflow:"hidden",
  display:'flex',
  position:"relative",
}));
export const OrganasationLogo = styled(Box)(() => ({
  position:"relative",
  zIndex:1,
  minWidth:"18.75rem",
  maxWidth:"18.75rem",
  backgroundColor: theme.colors.light.light,
  display:"flex",
  alignItems:"center",
  justifyContent:"center",
  padding:"1.25rem 5rem 1.25rem 1.875rem",
  clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
  filter: "drop-shadow(30px 10px 4px #4444dd)",
  "&:after":{
    content:`""`,
    position:"absolute",
    width:"20%",
    height:"75%",
    backgroundColor: theme.colors.secondary.light,
    right:0,
    bottom:0,
    transformOrigin:"left bottom",
    transform:"skew(-10deg, 30deg)",
  }
}));

export const OrganasationName = styled(Box)(() => ({
  position:"relative",
  flex:1,
  padding:"0.9375rem 2.5rem",
  "&:after":{
    content:`""`,
    position:"absolute",
    width:"1.875rem",
    height:"75%",
    backgroundColor: theme.colors.secondary.light,
    right:0,
    bottom:0,
    transformOrigin:"right bottom",
    transform:"skewX(-15deg)",
  }
}));


export const OrganizationSticky = styled(Box)(() => ({
  marginBottom: "2.5rem",
  position: "sticky",
  top: "0",
  left: "0",
  zIndex: "1",
}));
export const HeaderBorder = styled(Box)(() => ({
  borderRight: "1px solid transparent",
  borderImageSource:
    "linear-gradient(180deg, #FFFFFF 0.07%, #ACACAC 54.45%, #FFFFFF 100%)",
  borderImageSlice: "1",
}));

export const ProfileHeaderIocn = styled(Box)(() => ({
  position: "absolute",
  top: "1.25rem",
  right: "1.25rem",
}));



//=====Import-Attendance=====
export const ImportAttendance = styled(Box)(() => ({
  border: "0.094rem dashed #717171",
  backgroundColor: "#EFEFEF",
  width: "100%",
  padding: "3.625rem 0.938rem",
  margin: "auto",
  borderRadius: "1.25rem",
}));
//=====Import-Attendance=====

//=====Card-view=====
// ========================================
// Card View Components
// ========================================
export const Card = styled(Box)(() => ({
  ...cardStyles,
  boxShadow: "none",
  padding: 0,
  borderRadius: theme.radius.lg,
  // flexGrow: 1,
  // flexBasis: 0,
  // backgroundColor: theme.colors.light.light,
  "& + &": { marginBlockStart: theme.space[5] },
  "&:last-child":{
    flexGrow: 1,
    flexBasis: 0,
  }
}));

export const CardHeading = styled(Flex)(({Divider}) => ({
  paddingBottom: theme.space[5],
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom:Divider && theme.space[5],
  fontSize:theme.fontSize.lg,
  borderBlockEnd: Divider ? `${theme.colors.default.main } solid 0.0625rem}` : "none",
}));

export const CardViewBox = styled(Box)(() => ({
  boxShadow:
    "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
  borderRadius: theme.radius.list,
  padding: "10px",
  position: "relative",
}));
export const CardViewBoxBorder = styled(Box)(() => ({
  width: "100%",
  height: "5px",
  borderTop: "1px dashed #dbdcdc",
  margin: "10px 0",
}));

export const ViewLightBG = styled(Box)(() => ({
  backgroundColor: "#F1F5FA",
  borderRadius: "5px",
}));

//=====Card-view=====
export const BankCard = styled(Box)(() => ({
  position: "relative",
  backgroundColor: lighten(0.65, theme.colors.primary.main),
  backgroundSize: "cover",
  padding: "1.5rem",
  borderRadius: theme.radius.card,
  width: "100%",
  boxShadow: `0 0.3125rem 0.625rem ${rgba(theme.colors.dark.dark, 0.1)}`,
}));
export const BankCardBg = styled(Box)(() => ({
  position: "absolute",
  width: "104%",
  height: "104%",
  left: "-2%",
  top: "-2%",
  "& img": {
    mixBlendMode: "soft-light",
    opacity: 0.8,
  },
}));

// attendance-List
export const AttendaceTable = styled("table")(() => ({
  width: "100%",
  borderCollapse: "collapse",
  textAlign: "left",
}));
export const AttendaceThead = styled("thead")(() => ({
  "& tr": {
    backgroundColor: "#eeeff2",
  },
}));
export const AttendaceTr = styled("tr")(() => ({
  borderBlockEnd: "#D0D5DD solid 0.03125rem",
  textAlign: "left",
  whiteSpace: "nowrap",
  fontSize: "0.875rem",
  color: "#475467",
}));
export const AttendaceTH = styled("th")(() => ({
  padding: "0.75rem 1.5rem",
  "& p": {
    whiteSpace: "nowrap",
  },
}));

export const AttendaceTbody = styled("tbody")(() => ({
  "& tr:hover": {
    backgroundColor: "#f7f7f7",
  },
}));
export const AttendaceTd = styled("td")(() => ({
  padding: "0.75rem 1.5rem",
}));
export const TableResponsive = styled(Box)(() => ({
  overflow: "auto",
  height: "calc(100vh - 16.875rem)",
}));

export const CardBoxshadow = styled(Box)(() => ({
  padding: "0.625rem",
  backgroundColor: "#fff",
  borderRadius: "0.375rem",
  boxShadow:
    "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
}));
// attendance-List

// attendance-Modal
export const AttendanceTxtBx = styled(Box)(() => ({
  padding: "0.625rem",
  backgroundColor: theme.colors.light.main,
  borderRadius: theme.radius.element,
  border: `0.063rem solid ${theme.colors.light.dark}`,
  "& h4": {
    fontSize: "0.875rem",
    lineHeight: "normal",
  },
}));

export const TimerBox = styled(Box)(() => ({
  backgroundColor: theme.colors.light.main,
  width: "8.125rem",
  height: "8.125rem",
  borderRadius: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: `0.5rem solid ${theme.colors.light.dark}`,
  margin: "auto",
}));

export const PunchUl = styled("ul")(() => ({
  padding: "0",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    left: "-0.313rem",
    top: "-0.188rem",
    width: "0.625rem",
    height: "0.625rem",
    backgroundColor: theme.colors.light.light,
    zIndex: "1",
  },
}));

export const PunchLi = styled("li")(() => ({
  listStyle: "none",
  borderLeft: `0.063rem solid ${theme.colors.light.dark}`,
  paddingLeft: "1.25rem",
  paddingBottom: "1.875rem",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    left: "-0.5rem",
    top: "0.5rem",
    width: "0.625rem",
    height: "0.625rem",
    backgroundColor: theme.colors.light.light,
    borderRadius: "50%",
    border: `0.188rem solid ${theme.colors.primary.dark}`,
  },
}));

export const AttendanceBx = styled(Box)(() => ({
  padding: "1.25rem",
  height: "100%",
}));
export const AttendanceBxWraper = styled(Box)(() => ({
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    backgroundColor: "transparent",
    width: "0.063rem",
    height: "100%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderLeft: `0.063rem solid ${theme.colors.light.dark}`,
  },
}));
export const PunchUlScroll = styled(Box)(() => ({
  height: "23.75rem",
  overflow: "auto",
  paddingLeft: "0.438rem",
}));
// attendance-Modal

// Leave-Table
export const LeaveTable = styled("table")(() => ({
  border: `0.063rem solid ${theme.colors.light.dark}`,
  width: "100%",
  borderCollapse: "collapse",
  "& p": {
    whiteSpace: "nowrap",
  },
}));
export const LeaveThead = styled("thead")(() => ({
  border: `0.063rem solid ${theme.colors.light.dark}`,
}));
export const LeaveTr = styled("Tr")(() => ({
  border: `0.063rem solid ${theme.colors.light.dark}`,
}));
export const LeaveTh = styled("th")(() => ({
  border: `0.063rem solid ${theme.colors.light.dark}`,
  verticalAlign: "middle",
  padding: "0.625rem",
}));

export const LeaveBody = styled("tbody")(() => ({
  border: `0.063rem solid ${theme.colors.light.dark}`,
  verticalAlign: "top",
  padding: "0.625rem",
}));
export const LeaveTd = styled("td")(() => ({
  border: `0.063rem solid ${theme.colors.light.dark}`,
  verticalAlign: "top",
  padding: "0.625rem",
}));
export const LeaveTableResponsive = styled(Box)(() => ({
  maxHeight: "20rem",
  overflow: "auto",
}));

// Leave-Table

// Employee-portal-dashboard
export const Empbx = styled(Box)(({ height }) => ({
  border: "1px solid #ECEEF6",
  boxShadow: "0px 0px 10px 0px #0000001A",
  borderRadius: "10px",
  padding: "1.25rem",
  backgroundColor: "#fff",
  height: height ? `${height}%` : "auto",
}));

export const EmPortalLayout = styled("section")(() => ({
  position: "relative",
  height: "100%",
  width: "100%",
  padding: "1.25rem",
  backgroundColor: "#f2f5fe",
}));

export const AttendaceTime = styled(Box)(() => ({
  border: "0.063rem solid #ECEEF6",
  boxShadow: "0px 0px 10px 0px #0000001A",
  borderRadius: "0.625rem",
  backgroundColor: "#fff",
}));

export const ProfileWraper = styled(Box)(() => ({
  width: "6.25rem",
  height: "6.25rem",
  borderRadius: "100%",
  margin: "auto",
  position: "relative",
  backgroundColor: "#fff",
  "& img": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "10px",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "100%",
  },
}));

export const TtlPercentage = styled(Box)(() => ({
  backgroundColor: "#EEF6FF",
  padding: "3px 5px",
  borderRadius: "9px",
  textAlign: "center",
  color: "#003D92",
  fontSize: "12px",
  fontWeight: "600",
  zIndex: "9",
  position: "relative",
  border: "6px solid #FFFFFF",
  width: "62px",
  margin: "-17px auto",
}));

export const TimeBox = styled(Flex)(() => ({
  alignItems: "center",
  backgroundColor: "#EEF6FF",
  padding: "10px 30px 10px 11px",
  borderRadius: "10px",
  gap: "10px",
}));

export const EmpbxIicon = styled(Box)(() => ({
  width: "30px",
  height: "30px",
  color: "#004AA8",
}));

export const ThumbContainer = styled(Box)(() => ({
  width: "16.875rem",
  height: "16.875rem",
  backgroundColor: "#fff",
  borderRadius: "100%",
  margin: "auto",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
export const ThumbChild = styled(Box)(() => ({
  width: "80%",
  height: "80%",
  backgroundColor: "#fff",
  border: "1px solid #C1C1C1",
  borderRadius: "100%",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const TimeBoxWhite = styled(Box)(() => ({
  boxShadow: "0px 0px 8px 0px #00000014",
  borderRadius: "15px",
  padding: "13px  37px",
  textAlign: "center",
}));
export const HolidayCard = styled(Box)(() => ({
  backgroundSize: "cover",
  backgroundPosition: "center",
  width: "100%",
  borderRadius: "0.625rem",
  overflow: "hidden",
}));
export const EmpRound = styled(Box)(() => ({
  color: "#0A1D56",
  backgroundColor: "#F6F7F8",
  width: "50px",
  height: "50px",
  borderRadius: "100%",
  padding: "10px",
}));

export const ProgressBarContainer = styled(Box)(() => ({
  backgroundColor: "#E1E1E1",
  width: "100%",
  height: "0.438rem",
  borderRadius: "0.938rem",
  position: "relative",
  overflow: "hidden",
}));
export const ProgressBar = styled(Box)(() => ({
  position: "absolute",
  top: "0",
  left: "0",
  height: "100%",
  borderRadius: "0.938rem",
}));

export const NetpaybleText = styled(Box)(() => ({
  position: "relative",
  paddingLeft: "20px",
  fontSize: "16px",
  fontWeight: "bold",
  "&::after": {
    content: '""',
    position: "absolute",
    width: "14px",
    height: "14px",
    backgroundColor: "#004AA8",
    top: "3px",
    left: "0",
    borderRadius: "100%",
  },
}));

export const DeductionsText = styled(Box)(() => ({
  position: "relative",
  paddingLeft: "1.25rem",
  fontSize: "1rem",
  fontWeight: "bold",
  "&::after": {
    content: '""',
    position: "absolute",
    width: "0.875rem",
    height: "0.875rem",
    backgroundColor: "#EA5743",
    top: "0.188rem",
    left: "0",
    borderRadius: "100%",
  },
}));

export const Addpreference = styled(Box)(() => ({
  borderRadius: "0.75rem",
  border: `0.063rem solid ${theme.colors.light.dark}`,
  padding: "0.5rem 0.75rem",
  width: "100%",
  display: "flex",
  gap: "0.5rem",
  alignItems: "center",
}));

export const AddpreferenceList = styled(Flex)(() => ({
flexDirection: "column",
gap: "0.5rem",
}));

export const Speedometer = styled(Box)(() => ({
  width: "100%",
  height: "15,625rem",
  margin: "0 auto",
  position: "relative" 
}));

// export const speedometer = {
//   width: "100%",
//   height: "15.625rem", 
//   margin: "0 auto",
//   position: "relative",
// };

export const TreeStyle = styled("ul")(() => ({
  display: "flex",
  flexDirection: "column",
  listStyle: "none",
  padding: 0,
  margin: 0,
  gap: "0.625rem",
  "&>li": {
    position: "relative",
    transition: "all .3s",
    borderRadius: theme.radius.list,
    "&.active": {
      // backgroundColor:theme.colors.background.main,
      backgroundColor: lighten(0.35, theme.colors.secondary.main),
    },
  },
}));


export const TreeTitle = styled(Flex)(() =>  {
  return {
    cursor: "pointer",
    color: theme.colors.primary.light,
    fontSize: "1rem",
    fontWeight: 500,
    padding: "0.5rem 0.75rem 0.5rem 1.25rem",
    gap: "0.875rem",
    display: "flex",
    alignItems: "center",
    position: "relative",
    whiteSpace: "nowrap",
    flexWrap: "nowrap",
    overflow: "hidden",
    borderRadius: theme.radius.list,
    backgroundColor: rgba(theme.colors.background.main, 0.5),
    "&:hover": {
      backgroundColor: rgba(theme.colors.background.main, 1),
    },
    "&.active": {
      // backgroundColor:rgba(theme.colors.secondary.light,0.15),
      backgroundColor: rgba(theme.colors.background.main, 1),
      color: theme.colors.primary.dark,
      fontWeight: 600,
    },
  };
});
export const TreeIcon = styled(Flex)(() => ({
  width: "1.5rem",
  minWidth: "1.5rem",
  height: "1.75rem",
  alignItems: "center",
  justifyContent: "center",
}));
export const ExpandIcon = styled(Flex)(() => ({
  width: "0.9375rem",
  minWidth: "0.9375rem",
  height: "0.9375rem",
  alignItems: "center",
  justifyContent: "center",
}));

export const TreeSubStyle = styled("div")(({ sx = {} }) => ({
  padding: 0,
  position: "relative",
  zIndex: 2,
  overflow: "hidden",
  transition: "max-height 0.3s",
  ...sx,
  "&.collapseNav": {
    position: "absolute",
    left: "calc(100% + 0.625rem)",
    top: 0,
    borderEndEndRadius: theme.radius.list,
    borderStartEndRadius: theme.radius.list,
    backgroundColor: theme.colors.light.light,
    boxShadow: `0px 0.125rem 0.9375rem ${rgba(theme.colors.dark.dark, 0.05)} `,
  },
  "& ul": {
    display: "flex",
    flexDirection: "column",
    margin: 0,
    padding: "0.625rem",
    listStyle: "none",
    gap: "0.625rem",
    transition: "max-height 0.3s",
  },
  "& li": {
    paddingInline: "2.5rem 1.375rem",
    position: "relative",
    // "&:last-child":{marginBlockEnd:"0.625rem"},
    "&:before": {
      content: `''`,
      position: "absolute",
      left: "1.25rem",
      bottom: "50%",
      height: "3.75rem",
      width: "1.25rem",
      borderEndStartRadius: "0.938rem",
      border: `${rgba(theme.colors.dark.dark, 0.2)} solid 0.0625rem`,
      borderBlockStart: "0",
      borderInlineEnd: "0",
    },
    "&.disable":{
      opacity:0.6,
      pointerEvents: "none",
    }
  },
}));

export const TreeSubTitle = styled(TreeTitle)(() => ({
  fontSize: "0.875rem",
  fontWeight: 400,
  padding: "0.625rem",
  borderRadius: theme.radius.element,
  transition: "all .3s",
  "&:hover": {
    // backgroundColor:rgba(theme.colors.default.main,0.5),
    backgroundColor: theme.colors.light.light,
  },
  "&.active": {
    backgroundColor: theme.colors.light.light,
    color: theme.colors.primary.dark,
    fontWeight: 500,
    paddingInlineStart: "1.25rem",
  },
}));



export const RegisterBx = styled(Flex)(() => ({
  width: "100%",
  height: "15.938rem",
  backgroundColor: theme.colors.background.main,
  padding: "1.25rem",
  alignItems: "center",
  justifyContent: "center",
}));

export const RegisterLogo = styled("div")(() => ({
  width: "8.75rem",
  height: "8.75rem",
  backgroundColor: theme.colors.light.light,
  borderRadius: "100%",
  padding: "1.875rem",
}));
